export const getMessagesQuery = `
  query GetMessages($chatId: ID!, $limit: Int, $nextToken: String) {
    getMessages(chatId: $chatId, limit: $limit, nextToken: $nextToken) {
      items {
        id
        chatId
        senderId
        receiverId
        text
        read
        createdAt
      }
      nextToken
    }
  }
`;

export interface Message {
  id: string;
  chatId: string;
  senderId: string;
  receiverId: string;
  text: string;
  createdAt: string;
}

export interface MessagesConnection {
  items: Message[];
  nextToken: string | null;
}

export interface GetMessagesResponse {
  getMessages: MessagesConnection;
}

export interface GetMessagesVariables {
  chatId: string;
  limit?: number;
  nextToken?: string;
}
